<div>
  <div class="row">
    <h3 class="label col-4 col-sm-2 col-lg-1">{{ milestoneName.toLowerCase()=='closed' ? 'Approvals': 'Clearances' }}</h3>
    <ul class="tallies col-8">
      @if (isApprovalOption(milestoneName, 'yes')) {
        <li class="yes">
          <mat-icon>check_circle</mat-icon>
          <span class="tally">{{ tallyApprovals("yes") }}</span>
        </li>
      }
      @if (isApprovalOption(milestoneName, 'maybe')) {
        <li class="maybe">
          <mat-icon>error</mat-icon>
          <span class="tally">{{ tallyApprovals("maybe") }}</span>
        </li>
      }
      @if (isApprovalOption(milestoneName, 'no')) {
        <li class="no">
          <mat-icon>cancel</mat-icon>
          <span class="tally">{{ tallyApprovals("no") }}</span>
        </li>
      }
      @if (isApprovalOption(milestoneName, 'discuss')) {
        <li class="discuss">
          <mat-icon>chat_bubble</mat-icon>
          <span class="tally">{{ tallyApprovals("discuss") }}</span>
        </li>
      }
      @if (isApprovalOption(milestoneName, 'unknown')) {
        <li class="unknown">
          <mat-icon>help_outline</mat-icon>
          <span class="tally">{{ tallyApprovals("unknown") }}</span>
        </li>
      }
    </ul>
  </div>
  <ul class="approvals-list">
    @for (approvalType of usedApprovalTypes; track approvalType) {
      <app-committee-approval
        [approvalType]="approvalType"
        [approval]="getApprovalForType(approvalType)"
        [approvalTypes]="usedApprovalTypes"
        (approvalChange)="updateApproval($event)"
        [isMilestoneMember]="isVotingMember(approvalType)"
        [projectId]="projectId"
        [milestoneId]="milestoneId"
        [milestoneName]="milestoneName"
        [readOnly]="readOnly"
        >
      </app-committee-approval>
    }
  </ul>
</div>
